import { render, staticRenderFns } from "./MonthlyEPFAffin.vue?vue&type=template&id=b375f21c"
import script from "./MonthlyEPFAffin.vue?vue&type=script&lang=js"
export * from "./MonthlyEPFAffin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports